import { render, staticRenderFns } from "./PreviewImg.vue?vue&type=template&id=30562bd5&scoped=true&"
import script from "./PreviewImg.vue?vue&type=script&lang=js&"
export * from "./PreviewImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30562bd5",
  null
  
)

export default component.exports